export { default as SkeletonDeploymentGroup } from './Skeleton';
